module.exports = __webpack_public_path__ + "media/images/about-slider-img-01-f87ee171ba9e8aa1c60a4c1bdeef6024.jpg";